import { render, staticRenderFns } from "./ShippingCarriers.vue?vue&type=template&id=33efdf4f"
import script from "./ShippingCarriers.vue?vue&type=script&lang=js"
export * from "./ShippingCarriers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports